// extracted by mini-css-extract-plugin
export default {"container-list":"List_container-list__dr-cy","add-container":"List_add-container__mjegD","proyect-container":"List_proyect-container__xePLc","but":"List_but__mJeAJ"};